"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValuesFromCollection = exports.getCollectionValue = exports.getSharedValue = void 0;
function getSharedValue(store, key) {
    return getStoreValue(store, key.id, () => key.defaultValue);
}
exports.getSharedValue = getSharedValue;
function getCollectionValue(collection, indexKey, key) {
    return getStoreValue(collection, key, indexKey.defaultKeyValue);
}
exports.getCollectionValue = getCollectionValue;
function getStoreValue(store, key, defaultValue) {
    let value = store.getValue(key);
    if (defaultValue && (value === null || value === undefined)) {
        const newValue = defaultValue(key);
        if (newValue !== value) {
            value = newValue;
            store.setValue(key, value);
        }
    }
    return value;
}
function getValuesFromCollection(collection, key, keys) {
    const values = {};
    for (const valueKey of keys) {
        values[valueKey] = getCollectionValue(collection, key, valueKey);
    }
    return values;
}
exports.getValuesFromCollection = getValuesFromCollection;
//# sourceMappingURL=shared-store-reader.js.map